import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useSelector } from 'react-redux'
import './ViewDownloadDocument.scss';
import HrbTranslate from '../../language/HrbTranslate';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { trackEvent } from '../../../services/util/AnalyticsUtil';
import { Permissions } from '../../../app/services/Permissions';
import { useFileDownload } from '../../../pages/vdo-ticket/components/dox/Explorer/hooks/useFileDownloadHook';
import { DoxFileOperationStatus } from '../../../pages/vdo-ticket/components/dox/Explorer/services/doxExplorerConsts';

const ViewDownloadDocument = ({ documentType, ticketId, onViewDownloadFail, disabled }) => {
    const [downloading, setDownloading] = useState(false);
    const [viewing, setViewing] = useState(false)
    const [hasError, setHasError] = useState(false);

    const [, , handleOpenFileByType] = useFileDownload()

    const hasDocPermission = useSelector(state => (state.accountData.permissions || [])
            .includes(Permissions.VIEW_DOCUMENTS))

    const shouldTrack = () => {
        return ['Interview', 'EAFPrimary', 'EAFSpouse', 'MR69Primary', 'MR69Spouse'].includes(documentType);
    }

    const handleViewClick = async () => {
        if (viewing || !hasDocPermission) {
            return
        }
        setViewing(true)
        let response = await handleOpenFileByType('view', ticketId, documentType)
        if (response !== DoxFileOperationStatus.COMPLETE) {
            handleError()
        } else {
            if (shouldTrack()) {
                trackEvent(`Spark-${documentType}View`, ticketId)
            }
        }
        setViewing(false)
    }

    const handleDownloadClick = async () => {
        if (downloading || !hasDocPermission) {
            return
        }

        setDownloading(true);
        let response = await handleOpenFileByType('download', ticketId, documentType)
        if (response !== DoxFileOperationStatus.COMPLETE) {
            handleError()
        } else {
            if (shouldTrack()) {
                trackEvent(`Spark-${documentType}View`, ticketId)
            }
        }
        setDownloading(false);
    }

    const handleError = () => {
        if (onViewDownloadFail) {
            onViewDownloadFail(documentType);
        }
        trackEvent(`Spark-${documentType}Error`, ticketId)
        setHasError(true);
    }

    return (
        <div className={classnames('view-download-holder', { 'vdh-disabled': disabled })}>
            <span className='graphic'><PictureAsPdfIcon /></span>
            <span>
            <span className='vd-label'>
                <HrbTranslate text={`Documents.Label.${documentType}`} />
            </span>
            {!disabled && !hasError &&
                <Fragment>
                    <a onClick={handleViewClick} className={classnames({ 'disabled': !hasDocPermission })}>
                        <HrbTranslate text='Documents.View' />
                    </a>
                    <span className='pipe'>|</span>
                    <a onClick={handleDownloadClick} className={classnames({ 'disabled': !hasDocPermission || downloading })}>
                        <HrbTranslate text='Documents.Download' />
                    </a>
                </Fragment>
                }
            </span>            
        </div>
    );
}

ViewDownloadDocument.propTypes = {
    documentType: PropTypes.string.isRequired,
    ticketId: PropTypes.number.isRequired,
    onViewDownloadFail: PropTypes.func,
    disabled: PropTypes.bool
}

export default ViewDownloadDocument;